import React from "react";
import { NavLink } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import { Nav } from "reactstrap";

var ps;

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.activeRoute.bind(this);
    }
    activeRoute(routeName) {
        return this.props.name == routeName ? "active" : "";
    }
    linkOnClick = () => {
        document.documentElement.classList.remove("nav-open");
    };
    render() {
        const { qClientColor, routes } = this.props;
        let logoImg = null;
        let logoText = null;
        return (
            <div className="sidebar" style={{ background: qClientColor }}>
                <div className="sidebar-wrapper" ref="sidebar">
                    {logoImg !== null || logoText !== null ? (
                        <div className="logo">
                            {logoImg}
                            {logoText}
                        </div>
                    ) : null}
                    <Nav>
                        {routes.map((route, key) => {

                            if (!route.name) return null
                            if (route.redirect) return null
                            if (route.name === "Grafico") return null
                            if (route.name === "Grafico2") return null
                            if (route.name === "Informazioni") return null
                            if (route.name === "Login") return null
                            if (route.name === "Simulazioni") return null
                            if (route.path.indexOf(':') > -1) return null

                            var title = route.name.split('|').map((item, i) => <p key={i}>{item}</p>);
                            //se la route accetta il livello di permessi dell'utente
                            if (this.props.user.roles.some((r) => route.roles.includes(r)))
                                return (
                                    <li
                                        className={
                                            this.activeRoute(route.name)
                                        }
                                        key={key}
                                    >
                                        <NavLink
                                            to={route.path}
                                            className="nav-link"
                                            activeClassName="active"
                                            onClick={this.props.toggleSidebar}
                                        >
                                            <i className={route.icon} />
                                            <div>{title}</div>
                                        </NavLink>
                                    </li>
                                );
                        })}
                    </Nav>
                </div>
            </div>
        );
    }
}

Sidebar.defaultProps = {
    rtlActive: false,
    // qClientColor: "primary",
    routes: [{}]
};

Sidebar.propTypes = {
    // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
    // insde the links of this component
    rtlActive: PropTypes.bool,
    // qClientColor: PropTypes.oneOf(["primary", "blue", "green"]),
    routes: PropTypes.arrayOf(PropTypes.object),
    logo: PropTypes.shape({
        // innerLink is for links that will direct the user within the app
        // it will be rendered as <Link to="...">...</Link> tag
        innerLink: PropTypes.string,
        // outterLink is for links that will direct the user outside the app
        // it will be rendered as simple <a href="...">...</a> tag
        outterLink: PropTypes.string,
        // the text of the logo
        text: PropTypes.node,
        // the image src of the logo
        imgSrc: PropTypes.string
    })
};

export default Sidebar;
